import { API, CompetitionAPI, Endpoints } from '@brg/api';
import { useEffect, useState } from 'react';
import useLocalization from '../useLocalization';
export var useGetCompetitionProject = function (competitionId, disabled) {
    var _a = useState(undefined), resp = _a[0], setResp = _a[1];
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(false), error = _c[0], setError = _c[1];
    var language = useLocalization().language;
    useEffect(function () {
        if (!competitionId || disabled)
            return;
        setIsLoading(true);
        API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/project/GetProjectsByCompetition')
            .get()
            .addQuery('competitionId', competitionId || '')
            .send()
            .then(function (r) { return (r ? r.json() : undefined); })
            .then(function (r) {
            setIsLoading(false);
            setResp((r === null || r === void 0 ? void 0 : r.length) > 0 ? r[0] : undefined);
        })
            .catch(function (e) {
            setIsLoading(false);
            setError(true);
        });
    }, [competitionId, disabled]);
    return [API.toLang(resp, language), isLoading, error];
};
//# sourceMappingURL=useGetCompetitionProject.js.mapimport { API, CompetitionAPI, Endpoints } from '@brg/api';
import { useEffect, useState } from 'react';
import useLocalization from '../useLocalization';
export var useGetCompetitionProject = function (competitionId, disabled) {
    var _a = useState(undefined), resp = _a[0], setResp = _a[1];
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(false), error = _c[0], setError = _c[1];
    var language = useLocalization().language;
    useEffect(function () {
        if (!competitionId || disabled)
            return;
        setIsLoading(true);
        API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/project/GetProjectsByCompetition')
            .get()
            .addQuery('competitionId', competitionId || '')
            .send()
            .then(function (r) { return (r ? r.json() : undefined); })
            .then(function (r) {
            setIsLoading(false);
            setResp((r === null || r === void 0 ? void 0 : r.length) > 0 ? r[0] : undefined);
        })
            .catch(function (e) {
            setIsLoading(false);
            setError(true);
        });
    }, [competitionId, disabled]);
    return [API.toLang(resp, language), isLoading, error];
};
//# sourceMappingURL=useGetCompetitionProject.js.map